import {
  makeAuthenticatedRequest,
  makeAuthenticatedRequestForFile,
} from "./api";

export const getPublicSchools = async () => {
  try {
    const response = await makeAuthenticatedRequest("/schools_public", "GET");
    if (!response.ok) return { ok: false, error: response };
    const data = await response.json();
    return { ok: true, data };
  } catch (error) {
    console.error("Error fetching schools:", error);
    return { ok: false, error: error.message };
  }
};

export const getRolesOfUsers = async () => {
  try {
    const URL = `/classrooms/getData`;
    return await makeAuthenticatedRequest(URL, "GET")
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during getting classrooms:", error);
    return { ok: false, error: error };
  }
};

export const createClassroom = async (payload) => {
  try {
    return await makeAuthenticatedRequestForFile(
      `/classrooms/`,
      "POST",
      payload
    )
      .then((response) => {
        // Check if the request was successful (status code 200-299)
        if (!response.ok) {
          return { ok: false, error: response };
        }
        // Parse the response as JSON
        return response.json();
      })
      .then((data) => {
        // Handle the JSON data
        return { ok: true, data: data };
      })
      .catch((error) => {
        // Handle errors
        console.error("Create classroom:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    // Handle network errors or unexpected issues
    console.error("Error during delete classroom:", error);
    return { ok: false, error: error };
  }
};

export const loginWithSessionToken = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/loginByToken`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        ok: false,
        error: errorData.error || "Login failed",
        email: errorData.email || null, // Return email if available in the error response
      };
    }

    return { ok: true, data: await response.json() };
  } catch (error) {
    console.error("Login error:", error);
    return { ok: false, error: error.message };
  }
};
